export enum PostbackEvents {
  fetchPostbackTable = 'fetchPostbackTable',
  openModalDeletePostback = 'openModalDeletePostback',
  openModalTestingPostback = 'openModalTestingPostback',
}
